import { create } from 'zustand';
import { shallow } from 'zustand/shallow';
import { BffGamesCategory } from '@lucky7ventures/bff-types';

export interface GamesCategoryNavStore {
  feature?: BffGamesCategory;
  provider?: string;
  category?: BffGamesCategory;
  liveCasinoCategory?: BffGamesCategory; // Used only for Ontario ATM, represents game id of active casino game from dropdown
}

type GamesCategoryNavActions = {
  setFeature: (feature?: BffGamesCategory) => void;
  setProvider: (provider?: string) => void;
  setCategory: (category?: BffGamesCategory) => void;
  setLiveCasinoCategory: (liveCasinoCategory?: BffGamesCategory) => void;
  reset: () => void;
};

type State = GamesCategoryNavStore;

const initialState: State = {
  feature: undefined,
  provider: undefined,
  category: undefined,
  liveCasinoCategory: undefined,
};

export const useGameCategoryNavStore = create<{ data: State } & GamesCategoryNavActions>(set => ({
  data: initialState,
  setFeature: (feature?: BffGamesCategory) => set(state => ({ data: { ...state.data, feature } })),
  setProvider: (provider?: string) => set(state => ({ data: { ...state.data, provider } })),
  setCategory: (category?: BffGamesCategory) =>
    set(state => ({ data: { ...state.data, category } })),
  setLiveCasinoCategory: (liveCasinoCategory?: BffGamesCategory) =>
    set(state => ({ data: { ...state.data, liveCasinoCategory } })),
  reset: () => set({ data: initialState }),
}));

export const useGameCategoryNavData = () => {
  return useGameCategoryNavStore(state => state.data, shallow);
};

export const useGameCategoryNavActions = () => {
  return useGameCategoryNavStore(
    state => ({
      setFeature: state.setFeature,
      setProvider: state.setProvider,
      setCategory: state.setCategory,
      setLiveCasinoCategory: state.setLiveCasinoCategory,
      reset: state.reset,
    }),
    shallow,
  );
};
